import React from 'react';
import ReactDOM from 'react-dom';

if (!React) {
    throw new Error('"rio-appnavigator" needs a global React on the page');
}

if (!ReactDOM) {
    throw new Error('"rio-appnavigator" needs a global ReactDOM on the page');
}

import DefaultAppNavigator from './components/DefaultAppNavigator';

export {
    DefaultAppNavigator,
};
